<template>
    <v-container>
        <v-row justify="center">
            <h2>
                <span class="pa-1">Moje recenzie</span>
            </h2>
        </v-row>
        <v-divider/>
       
        <v-container v-if="!noReviews">
            <v-container v-for="review in reviews" :key="review.orderCode">
            <v-col cols="16" class="my-n7">
              <v-card
              class="mt-4" 
              elevation="10"
            color="#385F73"
            dark
          >
          <v-card-subtitle>Recenzia</v-card-subtitle>
            <v-card-title class="subtitle mt-n7">
              {{ review.review }}
            </v-card-title>

            <v-card-actions>
               <v-rating
                class="ml-3 mt-n4"
                :value="parseFloat(review.rating)"
                color="amber"
                dense
                half-increments
                readonly
                size="25"
                />
            </v-card-actions>
             
          </v-card>
        </v-col>
        </v-container>
        </v-container>
        <v-container v-else>
            <span class="pa-1">Zatiaľ nemáš žiadne hodnotenie</span>
        </v-container>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import store from "../../store/store";

    export default {
        name: "CleanerReviews",
        data: () => ({
            loading: false,
            reviews:[],
            noReviews : false,
        }),
        methods:{
            fetchAllData(){
                axios.get(store.state.url.concat('getReviews.php'), {
                    params: {
                        user: localStorage.getItem('loggedUserId')
                    }
                }).then((response) => {
                    if(response.data.result){
                        if(response.data.result == 'noReviews') {
                            this.noReviews = true;
                            this.$emit('noReviews');
                        }
                    }else{
                        this.noReviews = false;
                        this.reviews = response.data;
                        this.$emit('reviews');
                    }
                })
            },
        },
        created(){
            this.fetchAllData();
        }
    }
</script>
